import { GenericObject } from '@dxb-web-ui-framework/common/types';
import {
  SuccessCallback,
  ErrorCallback,
} from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { ConfirmOTPResponseBody } from '../entities/ConfirmOTPResponseDTO';
import { ResendCodeResponseBody } from '../entities/ResendCodeResponseDTO';
import { FallbackOTPResponseBody } from '../entities/FallbackOTPResponseDTO';
import { VerifyEmailResponseBody } from '../entities/VerifyEmailResponseDTO';
import { IAuthorizationsService } from '../entities/IAuthorizationsService';
import { IAuthorizationsRepository } from '../entities/IAuthorizationsRepository';

export class AuthorizationsServiceImpl implements IAuthorizationsService {
  itemRepo: IAuthorizationsRepository;

  constructor(ir: IAuthorizationsRepository) {
    this.itemRepo = ir;

    this.ConfirmOTP = this.ConfirmOTP.bind(this);
    this.FallbackToOTP = this.FallbackToOTP.bind(this);
    this.ResendCode = this.ResendCode.bind(this);
    this.VerifyEmail = this.VerifyEmail.bind(this);
    this.WebAuthorization = this.WebAuthorization.bind(this);
  }

  WebAuthorization(data: GenericObject): Promise<{ status: string }> {
    return this.itemRepo.WebAuthorization(data);
  }

  ConfirmOTP(
    data: GenericObject,
    successCallback: SuccessCallback,
    errorCallback: ErrorCallback,
  ): Promise<ConfirmOTPResponseBody> {
    return this.itemRepo.ConfirmOTP(data, successCallback, errorCallback);
  }

  FallbackToOTP(data: GenericObject): Promise<FallbackOTPResponseBody> {
    return this.itemRepo.FallbackToOTP(data);
  }

  ResendCode(data: GenericObject): Promise<ResendCodeResponseBody> {
    return this.itemRepo.ResendCode(data);
  }

  VerifyEmail(data: GenericObject): Promise<VerifyEmailResponseBody> {
    return this.itemRepo.VerifyEmail(data);
  }
}
